// import axios from "axios";
// const react_app_base_url = process.env.REACT_APP_API_BASE_URL;
import axiosInstance from './../interceptor/interceptor';


export const transactionService = {
  deleteTransaction,
};

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};
// , "Authorization": `bearer ${localStorage.getItem('ed_token')}`

// Delete Transaction
function deleteTransaction(obj) {
  return axiosInstance
    .delete(`api?method=delete_transaction`, {data: obj});
}
